import http from "@/common/http";

export const companySelect = (keyword)=>{
	return new Promise((resolve, reject)=>{
		http.request({
			api:"company/selectByKeyword",
			type:"POST",
			data:{keyword},
			success:(res)=>{
				resolve(res)
			},
			error:((error)=>{
				reject(error)
			})
		})
	})
}
